import { z } from 'zod'

export const step2Schema = z.object({
  documentTypeUuid: z.string().min(1, 'Please select a Document type.'),
  checklists: z.array(z.string()),
  playbooks: z.array(z.string()),
  assignments: z.array(
    z.object({
      type: z.enum(['checklist', 'playbook']),
      uuid: z.string(),
      userUuid: z.string(),
    })
  ),
})
